// @flow

export const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const kebabToSnakeCase = (value: string) => value.replace(/-/g, '_');
export const snakeToKebabCase = (value: string) => value.replace(/_/g, '-');

export const snakeToPascalCase = (value: string) => value.split('_').map(capitalize).join('');
export const pascalToSnakeCase = (value: string) => camelToSnakeCase(pascalToCamelCase(value));

export const pascalToCamelCase = (value: string) => value.charAt(0).toLowerCase() + value.slice(1);
export const camelToPascalCase = (value: string) => capitalize(value);

export const camelToKebabCase = (value: string) => value.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
export const kebabToCamelCase = (value: string) => snakeToCamelCase(kebabToSnakeCase(value));

export const camelToSnakeCase = (value: string) => value.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
export const snakeToCamelCase = (value: string) => pascalToCamelCase(snakeToPascalCase(value));

export const kebabToPascalCase = (value: string) => camelToPascalCase(kebabToCamelCase(value));
export const pascalToKebabCase = (value: string) => snakeToKebabCase(pascalToSnakeCase(value));
